import { useCallback } from 'react';
import usePlatformConfig from '../../../common/react/usePlatformConfig';
import IMoney from '../../model/prices/IMoney';

const useMoney = (prices: IMoney[]) => {
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  // TODO: Please remove optional chain operator
  const isPrimaryPrice = useCallback(price => price?.currency === priceDisplay.primary.currency, [priceDisplay]);
  const isSecondaryPrice = useCallback(price => price?.currency === priceDisplay?.secondary?.currency, [priceDisplay]);

  const getPrimaryPrice = useCallback(
    (prices: IMoney[]) => prices?.find(price => isPrimaryPrice(price)),
    [priceDisplay],
  );
  const getSecondaryPrice = useCallback(
    (prices: IMoney[]) => prices?.find(price => isSecondaryPrice(price)),
    [priceDisplay],
  );

  const primaryPrice = getPrimaryPrice(prices);
  const secondaryPrice = getSecondaryPrice(prices);

  return { primaryPrice, secondaryPrice };
};

export default useMoney;
